import isObject from 'lodash/isObject.js';
/**
 * Walk a tree, calling the callback for any property name matching a value in the keys array.
 */
export function visit(tree, keys, callback) {
    const traverse = (obj, path) => {
        for (const [key, value] of Object.entries(obj)) {
            if (keys.includes(key)) {
                callback(value, [...path, key]);
            }
            if (isObject(value)) {
                traverse(value, [...path, key]);
            }
        }
    };
    traverse(tree, []);
}
/**
 * Walk a tree with JSONPath, calling the callback for matching properties.
 * Normalizes the resulting path
 */
export function visitJsonPath(tree, jsonPaths, callback) {
    const paths = jsonPaths.map((p) => p.split('.').slice());
    const testPaths = (propPath) => {
        return paths.findIndex((testPath) => {
            const isFromRoot = testPath[0] === '$';
            const tPath = isFromRoot ? testPath.slice(1) : testPath.slice().reverse();
            const pPath = isFromRoot ? propPath.slice() : propPath.slice().reverse();
            let isMatchingPath = isFromRoot ? tPath.length === pPath.length : tPath.length <= pPath.length;
            for (const [pI, pP] of pPath.entries()) {
                if (tPath[pI] === undefined || !isMatchingPath) {
                    break;
                }
                isMatchingPath = pP === tPath[pI] || tPath[pI] === '*';
            }
            return isMatchingPath;
        });
    };
    const traverse = (obj, path) => {
        for (const [prop, value] of Object.entries(obj)) {
            const propPath = [...path, prop];
            const foundIndex = testPaths(propPath);
            if (foundIndex > -1) {
                callback(value, propPath, foundIndex);
            }
            if (isObject(value)) {
                traverse(value, propPath);
            }
        }
    };
    traverse(tree, []);
}
